module.exports = __webpack_public_path__ + "img/chatJunProfile.dfbb7d6.png";